// ============================================
// components/PhoneCodePicker.jsx
// ============================================
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiSearch, FiCheck } from 'react-icons/fi';
import '../styles/Modals.scss';

const COUNTRIES = [
  { id: 101, name: 'India', code: '+91', flag: '🇮🇳', iso2: 'IN' },
  { id: 233, name: 'United States', code: '+1', flag: '🇺🇸', iso2: 'US' },
  { id: 232, name: 'United Kingdom', code: '+44', flag: '🇬🇧', iso2: 'GB' },
  { id: 38, name: 'Canada', code: '+1', flag: '🇨🇦', iso2: 'CA' },
  { id: 13, name: 'Australia', code: '+61', flag: '🇦🇺', iso2: 'AU' },
];

const PhoneCodePicker = ({ currentValue, onSelect, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCountries = searchQuery
    ? COUNTRIES.filter(
        (country) =>
          country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          country.code.includes(searchQuery)
      )
    : COUNTRIES;

  return (
    <AnimatePresence>
      <div className="modal-overlay" onClick={onClose}>
        <motion.div
          className="modal-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h3>Select Country Code</h3>
            <button className="close-button" onClick={onClose}>
              <FiX />
            </button>
          </div>

          <div className="search-container">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search country or code..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>

          <div className="options-list">
            {filteredCountries.map((country) => (
              <button
                key={country.id}
                className={`option-item ${currentValue === country.code ? 'selected' : ''}`}
                onClick={() => onSelect(country)}
              >
                <div className="country-info">
                  <span className="flag">{country.flag}</span>
                  <span className="name">{country.name}</span>
                  <span className="code">{country.code}</span>
                </div>
                {currentValue === country.code && (
                  <FiCheck className="selected-icon" />
                )}
              </button>
            ))}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default PhoneCodePicker;